import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import AddContact from "../../../components/Modal/AddContact";
import ContactCard from "./contactCard";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./contactsTable.constants";
import {useContactsSearchOptions} from "./useContactsSearchOptions";
import {useContactTableActions} from "./useContactTableActions";
import {useContactTableData} from "./useContactTableData";

const ContactsTable = () => {
  const {searchOptions} = useContactsSearchOptions();
  const {
    contactsList,
    contactTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
  } = useContactTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    deleteContactHandler,
    isDeleteModalOpen,
    isEditModalOpen,
    handleActionSelection,
    selectedRow,
  } = useContactTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isEditModalOpen && (
        <AddContact data={selectedRow} onCancel={closeEditModal} open={isEditModalOpen} />
      )}
      <DeleteModal
        header={"Delete Contact"}
        modalBody={"Are you sure you want to delete this Contact ?"}
        onClose={closeDeleteModal}
        onDelete={deleteContactHandler}
        open={isDeleteModalOpen}
      />
      <div className="table-container">
        <ListView
          listItems={contactsList}
          listHeaders={LIST_HEADERS}
          rowClickable
          onSelectAction={handleActionSelection}
          withActions
          actionsList={ACTIONS_LIST}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={contactTotalCount}
          withPagination={paginationConfig}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Contacts"}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={ContactCard}
        />
      </div>
    </Fragment>
  );
};

ContactsTable.propTypes = {};
export default ContactsTable;
